import { runtimeEnv } from '../config/runtimeEnv';

export const DEVICE_ID_KEY = 'deviceId';

export type RegistrationPlatform = 'IOS' | 'ANDROID' | 'WEB';

export type RegistrationMetadata = {
  deviceId: string;
  deviceName: string;
  platform: RegistrationPlatform;
  appVersion?: string;
};

const createDeviceId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const parseStoredDeviceId = (storedDeviceId: string): string => {
  try {
    const parsedDeviceId = JSON.parse(storedDeviceId);

    return typeof parsedDeviceId === 'string' ? parsedDeviceId : createDeviceId();
  } catch {
    return storedDeviceId;
  }
};

export const getOrCreateDeviceId = (): string => {
  try {
    const storedDeviceId = localStorage.getItem(DEVICE_ID_KEY);

    if (storedDeviceId) {
      return parseStoredDeviceId(storedDeviceId);
    }

    const deviceId = createDeviceId();
    localStorage.setItem(DEVICE_ID_KEY, JSON.stringify(deviceId));

    return deviceId;
  } catch {
    return createDeviceId();
  }
};

export const getRegistrationMetadata = (): RegistrationMetadata => ({
  deviceId: getOrCreateDeviceId(),
  deviceName: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
  platform: 'WEB',
  appVersion: runtimeEnv.version,
});
